import {
  AddWidgetRequestFilterPayload,
  ClearWidgetRequestFilterPayload,
  RequestFilterStateModel,
  WidgetRequestFilter,
} from '../../models/request-filter.model';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../index';

// identifier
export const REQUEST_FILTER_SLICE_ID = 'requestFlter';

// default state
const initialState: RequestFilterStateModel = {
  filters: [],
};

//slice
const requestFilterSlice = createSlice({
  name: REQUEST_FILTER_SLICE_ID,
  initialState,
  reducers: {
    addWidgetRequestFilter: (
      state: RequestFilterStateModel,
      action: PayloadAction<AddWidgetRequestFilterPayload>
    ): void => {
      const widgetFilterIndex = state.filters.findIndex(
        (filter) => filter.widgetId === action.payload.widgetId
      );
      if (widgetFilterIndex === -1) {
        state.filters.push(action.payload);
      } else {
        state.filters[widgetFilterIndex] = action.payload;
      }
    },
    clearWidgetRequestFilter: (
      state: RequestFilterStateModel,
      action: PayloadAction<ClearWidgetRequestFilterPayload>
    ): void => {
      const widgetFilterIndex = state.filters.findIndex(
        (filter) => filter.widgetId === action.payload.widgetId
      );
      if (widgetFilterIndex !== -1) {
        state.filters.splice(widgetFilterIndex, 1);
      }
    },
  },
});

//selectors
export const selectRequestFilterByWidgetId = (state: RootState, widgetId: string) =>
  state.requestFlter.filters.find((filter: WidgetRequestFilter) => filter.widgetId === widgetId)
    ?.filter;

//actions
export const { addWidgetRequestFilter, clearWidgetRequestFilter } = requestFilterSlice.actions;

export default requestFilterSlice;
